module.exports = __webpack_public_path__ + "static/img/union.7df9c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/union.png
// module id = KWSB
// module chunks = 1 3